import React from "react";
import { DEFAULT_OVERLAY_CONFIG } from "./constants";
import { StyledOverlay } from "./styled";
import { OverlayProps } from "./types";

const Overlay: React.FC<OverlayProps> = ({
    width = DEFAULT_OVERLAY_CONFIG.WIDTH,
    height = DEFAULT_OVERLAY_CONFIG.HEIGHT,
    color = DEFAULT_OVERLAY_CONFIG.COLOR,
    opacity = DEFAULT_OVERLAY_CONFIG.OPACITY,
    onClick,
}) => {
    return (
        <StyledOverlay
            width={width}
            height={height}
            backgroundColor={color}
            opacity={opacity}
            onClick={onClick}
        />
    );
};

export default Overlay;
